import React from "react";
import Star from "../images/star_logo.webp";
import { AUTH_SIGNUP, AUTHENTICATION_MODAL_ID } from "../../../redux/authentication/constants";
import { store } from "../../../redux";
import { setAuthState } from "../../../redux/actions";

const Mission = () => {
  return (
    <section className="mission-section">
      <div className="mission-content">
        <img src={Star} alt="Star Logo" className="mission-logo" />
        <h1 className="mission-title">Mission</h1>
        <h2 className="mission-sub-title">
          Empowering private market & IPO participation and prosperity for everyone.
        </h2>
        <p className="mission-description" style={{ color: "#a8a8a8" }}>
          Entrepreneurship and its equity creation are the most powerful ways to improve the world and grow wealth.
          Radivision believes broader participation in this ecosystem will transform how wealth is created and shared,
          while funding needed innovation. We engage, educate, and connect retail investors to private and IPO
          opportunities, thereby bringing transparency, access, and insight to a market historically reserved for
          institutions.
        </p>

        <div className="getting-started-header">
          <div className="gs-btn">
            <button
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={() => {
                store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
              }}
            >
              Join
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
